import React from 'react';
import { Button } from '@/components/ui/Button';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { ViewToggle } from '@/components/ui/ViewToggle';
import { Users } from 'lucide-react';

interface UserManagementHeaderProps {
  loading: boolean;
  onInviteClick: () => void;
  onRefresh: () => void;
}

export const UserManagementHeader: React.FC<UserManagementHeaderProps> = ({
  loading,
  onInviteClick,
  onRefresh,
}) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Users className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">이용자 관리</h2>
          <p className="text-sm text-gray-500 mt-1">사용자 계정을 관리하고 승인합니다</p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <Button onClick={onInviteClick}>
          사용자 초대
        </Button>
        <Button 
          variant="outline" 
          onClick={onRefresh}
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center space-x-2">
              <LoadingSpinner size="sm" />
              <span>새로고침 중...</span>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              <span>상태 새로고침</span>
            </div>
          )}
        </Button>
        <ViewToggle view="table" onViewChange={() => {}} enableCard={false} enableTable={true} />
      </div>
    </div>
  );
};

